var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.147,
    height: 286.187,
    viewBox: "0 0 375.147 286.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(0 -44.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    "data-name": "Caminho 766",
    d: "M344.96,44.48,119.147,270.293l-88.96-88.96L0,211.52,119.147,330.667l256-256Z",
    fill: "#000FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.749cf83895af261dfdce261e313252c7.svg";
export { ForwardRef as ReactComponent };